import Icon from 'veui/components/Icon'
import { IconPlusCircle } from 'dls-icons-vue'

Icon.register('plus-circle', IconPlusCircle)
